import { UserRoleVM } from './userRoles';

export enum RoleNames {
    Developer = 'Developer',
    Admin = 'Admin',
    Editor = 'Editor',
    DistrictWebsite = 'District Website',
    FineArts = 'Fine Arts',
    ESE = 'ESE',
    HUB = 'theHUB',
    Legislative = 'Legislative',
}

export interface Role {
    roleId: number;
    roleName: string;
    userRole?: UserRoleVM[];
}
